module.exports = __webpack_public_path__ + "img/mp.96ede005.png";